<div class="pos-panel">
    <div class="d-flex align-items-center justify-content-between" style="margin-top: 12px">
        <div class="pos-header-detailed">
            <span class="material-icons-round neutral-90 soc-cursor-pointer" (click)="goToTurnoverRecords()">arrow_back</span>
            <span class="soc-h3-light">{{'TURNOVER.ORDER' | translate}}</span>
            <span class="soc-h3-light soc-neutral-50-text-color">{{order.orderNumber}}</span> 
            <div class="soc-wrapper-gap-12 align-items-center">
                <span [ngClass]="order.typeString == 'Fiscal' ? 'soc-fiscal' : 'soc-thermal'"></span>
                <span class="soc-p">{{(order.typeString == 'Fiscal' ? 'ORDER.FISCAL': 'ORDER.THERMAL') | translate}}</span>
            </div>
        </div>
        <div class="soc-wrapper-gap-12">
            <div class="flex-column soc-wrapper-gap-8 align-items-end">
                <span class="soc-h1">{{order.waiter?.firstName}} {{order.waiter?.lastName}}</span>
                <span class="soc-p soc-secondary-text">Waiter</span>
            </div>
            
            <img alt="User Image" class="soc-employee-img" [src]="order.waiter?.profilePictureUrl ? order.waiter?.profilePictureUrl : 'assets/images/logo/profile-picture-placeholder.png'">
        </div>
    </div>
    <div class="d-flex justify-content-between">
        <div class="soc-info-grid">
            <div class="soc-wrapper-gap-12">
                <span class="material-icons cyan">calendar_month</span>
                <span class="soc-p">{{order.createdOn | date: 'EEE, d MMM y'}}</span>
            </div>
            <div class="soc-wrapper-gap-12">
                <span class="material-icons cyan">room_service</span>
                <span class="soc-p">{{order.groupName}}</span>
            </div>
            <div class="soc-wrapper-gap-12">
                <span class="material-icons cyan">watch_later</span>
                <span class="soc-p">{{order.createdOn | date: 'hh:mm a'}}</span>
            </div>
            <div class="soc-wrapper-gap-12">
                <span class="material-icons cyan">table_bar</span>
                <span class="soc-p">{{orderTables}} </span>
            </div>

        </div>
        <div class="soc-input-wrapper" style="width: 324px;">
            <label class="soc-input-lbl w-100 text-start">{{'TURNOVER.BILLS' | translate}}</label>
            <p-dropdown appendTo="body" class="soc-dropdown soc-dropdown-search-separator soc-dropdown-btn-separator" [virtualScroll]="true" [filter]="true" [options]="order.bills ? order.bills : []"  optionLabel="billNumber" placeholder="{{order.bills?.length}} {{'ORDER_BILL.BILLS'| translate}}" filterPlaceholder="{{'SEARCH' | translate}}">
                <ng-template let-item pTemplate="item">
                    <div class="d-flex justify-content-between" (click)="$event.stopPropagation(); goToBill(item);">
                        <div class="soc-wrapper-gap-8">
                            <span>{{item.billNumber}}</span>
                            <span class="pi pi-circle-fill soc-cyan-dot-separator"></span>
                             <span class="soc-secondary-text">{{item.netAmount}}</span>
                        </div>
                        <span class="material-icons">navigate_next</span>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>
    </div>
    <p-table class="soc-table align-self-center w-100" [value]="order.lineItems ? order.lineItems : []" [scrollable]="true" [virtualScroll]="true" scrollHeight="calc(100vh - 568px)">
        <ng-template pTemplate="header">
            <tr> 
                <th [style.max-width]="'264px'">{{'TURNOVER.ITEMS' | translate}} <span class="secondary-td">({{ order.lineItems?.length}})</span></th> 
                <th>{{'TURNOVER.DIVISION' | translate}}</th> 
                <th [style.max-width]="'120px'">{{'TURNOVER.NET' | translate}}</th> 
                <th [style.max-width]="'120px'">{{'TURNOVER.TAX' | translate}}</th> 
                <th [style.max-width]="'120px'">{{'TURNOVER.TOTAL' | translate}}</th> 
                <th [style.max-width]="'96px'"></th>
            </tr> 
        </ng-template>
        <ng-template  pTemplate="body" let-lineItem  let-rowIndex="rowIndex">  
                <tr>
                    <td [style.max-width]="'264px'">{{lineItem.menuItem.name}}</td>
                    <td>{{lineItem.division.name}}</td>
                    <td [style.max-width]="'120px'" class="secondary-td"> {{currency.shortName ? (lineItem.menuItem.netPrice | currency: currency.shortName : true : '1.2-2' ) : (lineItem.menuItem.netPrice | number : '1.2-2')}}</td>
                    <td [style.max-width]="'120px'"class="secondary-td">{{currency.shortName ? (lineItem.menuItem.tax | currency: currency.shortName : true : '1.2-2' ) : (lineItem.menuItem.tax | number : '1.2-2')}} </td>
                    <td [style.max-width]="'120px'" class="secondary-td">{{currency.shortName ? (lineItem.menuItem.price  | currency: currency.shortName : true : '1.2-2' ) : (lineItem.menuItem.price | number : '1.2-2')}}</td>
                    <td [style.max-width]="'96px'" class="justify-content-end"><span pTooltip="{{order.note}}" tooltipPosition="bottom" class="material-icons hover-icon">sticky_note_2</span></td>
                </tr>                       
        </ng-template>
    </p-table>
   
    <div class="w-100 d-flex justify-content-end">
        <div class="soc-display-field-wrapper">
            <label class="soc-input-lbl w-100 text-end">{{'TURNOVER.ORDER_TOTAL' | translate }}</label>
            <div class="soc-display-field justify-content-end"> <span class="soc-h2 soc-success-color">{{ currency.shortName ? (( order.sumNet  ?  order.sumNet : '' )| currency : currency.shortName : true : '1.2-2') : ((order.sumNet ? order.sumNet : '') | number : '1.2-2' ) }}</span></div>
        </div>
    </div>
</div>

        